import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, ArrowRight } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { ProductCard } from "@/components/ProductCard";

const WishlistPage = () => {
  const { items } = useWishlist();

  return (
    <main data-testid="wishlist-page" className="min-h-screen bg-cream px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold-muted">
            Saved on this device
          </p>
          <h1 className="mt-3 font-serif text-4xl tracking-tight text-espresso sm:text-5xl">
            Your Wishlist
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-espresso/60">
            {items.length > 0
              ? `${items.length} ${items.length === 1 ? "treasure" : "treasures"} set aside for later.`
              : "Pieces you heart will wait for you here — no account needed."}
          </p>
        </motion.div>

        {items.length === 0 ? (
          <div
            data-testid="wishlist-empty-state"
            className="mt-12 rounded-sm border border-dashed border-gold/40 px-8 py-20 text-center"
          >
            <Heart size={32} strokeWidth={1} className="mx-auto text-gold-muted/50" />
            <h3 className="mt-5 font-serif text-2xl text-espresso">Nothing saved yet</h3>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-espresso/60">
              Tap the heart on any piece you love and it will be kept here for your next visit.
            </p>
            <Link
              to="/shop"
              data-testid="wishlist-browse-button"
              className="mt-8 inline-flex items-center gap-3 bg-gold px-8 py-4 font-mono text-[11px] uppercase tracking-[0.3em] text-espresso transition-all duration-300 hover:bg-gold-accent active:scale-[0.98]"
            >
              Browse the Collection <ArrowRight size={14} />
            </Link>
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3" data-testid="wishlist-grid">
            {items.map((p) => (
              <ProductCard key={p.id} product={p} testid={`wishlist-product-card-${p.id}`} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
};

export default WishlistPage;
